import { render, staticRenderFns } from "./spaceAdminData.vue?vue&type=template&id=10db9a68&scoped=true&"
import script from "./spaceAdminData.vue?vue&type=script&lang=js&"
export * from "./spaceAdminData.vue?vue&type=script&lang=js&"
import style0 from "./spaceAdminData.vue?vue&type=style&index=0&id=10db9a68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db9a68",
  null
  
)

export default component.exports